import React from 'react';
import {Paper, Typography} from "@mui/material";

import ProcurementContainer from '../../procurement/containers/ProcurementContainer';
import GivsList from '../lists/givsList';


const GivsPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        Givs
      </Typography>
      {/* <Paper sx={{my: 5}}>
        <CreateGivComponent/>
      </Paper> */}
      <Paper sx={{my: 5}}>
        <GivsList/>
      </Paper>
    </ProcurementContainer>

  )
}

export default GivsPage